export const FETCH_DIALOG_BADGES_FAILED = "error:dialogs.fetch-dialog-badges-failed"
export const FETCH_CURRENT_DIALOG_FAILED = "error:dialogs.fetch-current-dialog-failed"
export const FETCH_DIALOG_MESSAGES_FAILED = "error:dialogs.fetch-dialog-messages-failed"
export const FETCH_CLIENT_SURVEY_FAILED = "error:dialogs.fetch-client-survey-failed"

export const SEND_MESSAGE_FAILED = "error:dialogs.send-message-failed"
export const DELETE_MESSAGE_FAILED = "error:dialogs.delete-message-failed"
export const EDIT_MESSAGE_FAILED = "error:dialogs.delete-message-failed"

export const SET_HOT_KEY_FAILED = "error:fastReplies.hot-keys.setError"
export const DELETE_HOT_KEY_FAILED = "error:fastReplies.hot-keys.deleteError"

export const EMPTY_MESSAGE_INPUT = "\\"

export const SEND_OPERATOR_FEEDBACK_FAILED = "error:dialogs.send-operator-feedback-failed"

export const RENAME_FILE_FAILED = "error:dialogs.rename-file-failed"
export const ADD_FILE_TO_SECTION_FAILED = "error:dialogs.add-file-to-section-failed"
export const REMOVE_FILE_FROM_SECTION_FAILED = "error:dialogs.remove-file-from-section-failed"

export enum MESSAGE_DATAGRAM_TYPE {
    PROTO_HANDSHAKE = "PROTO_HANDSHAKE",
    PROTO_PREDICATE = "PROTO_PREDICATE"
}
